"use strict";

import angular from "angular";

import { Accounting } from "../../../../gateway/Accounting/Accounting";
import { DashboardAvailable } from "../../../../gateway/DashboardAvailable/DashboardAvailable";
import { GroupOfCompaniesGateway } from "../../../../gateway/GroupOfCompanies/GroupOfCompaniesGateway";
import { Point } from "../../../../gateway/Point/Point";
import { PointCalculated } from "../../../../gateway/PointCalculated/PointCalculated";
import { Serie } from "../../../../gateway/Serie/Serie";
import { Validations } from "../../../../imports/validations";
import { UserDataAdapter } from "../../../../presentation/adpters/UserDataAdapter";
import { LocalStoreService } from "../../../../presentation/services/LocalStoreService";
import { PopulateManager } from "../../../../presentation/services/PopulateManager/PopulateManager";
import { AvailablePopulateUsecase } from "../../../../usecases/available-populate.usecase";
import { GetCompaniesByIdsAndFilterUsecase } from "../../../../usecases/get-companies-by-ids-and-filter.usecase";

angular.module("nucont.accounting.company.reports").config(["$stateProvider", routeConfig]);

function routeConfig($stateProvider) {
    $stateProvider
        .state("nucont.accounting.company.reports", {
            url:
                "/meus-relatorios?report&feedbackIndex&feedbackType&scrollTo&download&userIdentify",
            lazyLoad(transition) {
                const $ocLazyLoad = transition.injector().get("$ocLazyLoad");
                return import(
                    /* webpackChunkName: "feature-accounting-company-reports" */ "./reports.entry"
                ).then(() => $ocLazyLoad.inject("nucont.accounting.company.reports"));
            },
            views: {
                "admin@nucont.accounting": {
                    component: "reportsListComponent",
                    bindings: { companyData: "CompanyData" }
                }
            },
            params: {
                download: null,
                report: null,
                feedbackIndex: null,
                feedbackType: null,
                userIdentify: null
            }
        })
        .state("nucont.reportLogin", {
            url:
                "relatorio/:companyId/:accountingId/:type/:userId/:reportId?liveToken&contactId&userIdentify",
            params: {
                liveToken: null,
                reportId: null,
                contactId: null,
                userIdentify: null
            },
            views: {
                "main@": {
                    component: "emptyLayoutComponent"
                },
                "empty@nucont.reportLogin": {
                    template: `
                        <div class="splash-screen" ng-cloak="">
                            <div class="splash-screen__container">
                                <img src="assets/icons/nucont-icon.svg" alt="" />
                            </div>
                        </div>`
                }
            },
            resolve: {
                checkLogin: [
                    "$stateParams",
                    "$state",
                    "JWTService",
                    async ($stateParams, $state, JWTService) => {
                        const types = {
                            dashboard: "visualization",
                            monitoring: "rules",
                            dre: "dre",
                            dreComparation: "dre.comparation",
                            balance: "balance",
                            balanceComparation: "balance.comparation",
                            projection: "projection",
                            budget: "budget"
                        };
                        const { liveToken } = $stateParams;
                        if (!liveToken) {
                            console.log("REPORT NO TOKEN");
                            JWTService.signout();
                            return;
                        }
                        try {
                            await JWTService.signByToken(liveToken);
                            Validations.setConfigs();
                            const group = await new GroupOfCompaniesGateway().findById(
                                $stateParams.companyId
                            );
                            const companyType = group?._id
                                ? "group"
                                : "company";
                            const state = `nucont.reports.${companyType}.${
                                types[$stateParams.type]
                            }`;
                            const user = JWTService.user;
                            const profile = user.profile || {};
                            const _user = {
                                ...user,
                                profile: {
                                    ...profile,
                                    name: user.name,
                                    anonymous: user.isAnonimo,
                                    isAnonimo: user.isAnonimo
                                },
                                roles: [user.role]
                            };
                            const params = {
                                reportId: $stateParams.reportId,
                                id: $stateParams.companyId,
                                accountingId: $stateParams.accountingId,
                                arrowRule: true,
                                fromEmail: true,
                                contactId: $stateParams.contactId,
                                userIdentify: $stateParams.userIdentify,
                                user: _user
                            };
                            if (params.userIdentify === "undefined")
                                delete params.userIdentify;
                            $state.go(state, params);
                        } catch (error) {
                            JWTService.signout();
                        }
                    }
                ]
            }
        })
        .state("nucont.reports", {
            abstract: true
        })
        .state("nucont.reports.company", {
            url:
                "contabilidade/:accountingId/empresa/:id/relatorios?report&feedbackIndex&feedbackType&scrollTo&download&userIdentify&accIdReference&liveToken",
            lazyLoad(transition) {
                const $ocLazyLoad = transition.injector().get("$ocLazyLoad");
                return import(
                    /* webpackChunkName: "feature-accounting-company-reports" */ "./reports.entry"
                ).then(() => $ocLazyLoad.inject("nucont.accounting.company.reports"));
            },
            params: {
                accountingId: {
                    value: null
                },
                id: {
                    value: null
                },
                download: null,
                report: null,
                feedbackIndex: null,
                feedbackType: null,
                userIdentify: null,
                liveToken: null,
                user: null
            },
            views: {
                "main@": {
                    component: "emptyLayoutComponent"
                }
            },
            resolve: {
                accountingData: [
                    "$stateParams",
                    async ($stateParams) => {
                        const AccountingGetaway = new Accounting();
                        const accountingData = await AccountingGetaway.getById(
                            $stateParams.accountingId
                        );
                        const localStoreService = new LocalStoreService();
                        localStoreService.setItem("accounting", {
                            _id: accountingData?._id,
                            name: accountingData?.name,
                            plan: accountingData?.plan?.name,
                            contract: accountingData?.contract,
                            status: accountingData?.status,
                            createdAt: accountingData?.createdAt
                        });
                        return accountingData;
                    }
                ],
                CompanyData: [
                    "$stateParams",
                    async ($stateParams) => {
                        const getCompaniesByIdsAndFilterUsecase = new GetCompaniesByIdsAndFilterUsecase();
                        const companies = await getCompaniesByIdsAndFilterUsecase.execute(
                            {
                                companyIds: [$stateParams.id]
                            }
                        );
                        const companyData = companies[0];
                        const localStoreService = new LocalStoreService();
                        localStoreService.setItem("company", {
                            _id: companyData?._id,
                            name: companyData?.name,
                            segment: companyData?.segment?.t,
                            segmentGroup: companyData?.segmentGroup,
                            size: companyData?.size,
                            taxation: companyData?.taxation
                        });
                        return companyData;
                    }
                ],
                user: [
                    "$stateParams",
                    async ($stateParams) => {
                        let user = {};
                        if ($stateParams.user) {
                            user = $stateParams.user;
                        } else {
                            user = new UserDataAdapter().user();
                        }
                        const localStorageService = new LocalStoreService();
                        localStorageService.setItem("user", user);
                        return user;
                    }
                ],
                AvailablePopulate: [
                    "$stateParams",
                    async ($stateParams) => {
                        new Point().deleteMany({});
                        new PointCalculated().deleteMany({});
                        new PopulateManager().deleteMany({});
                        new Serie().deleteMany({});
                        const dashboardAvailable = new DashboardAvailable();
                        const availablePopulateUsecase = new AvailablePopulateUsecase();
                        const companyId = $stateParams.id;
                        const [available, dashboardsIds] = await Promise.all([
                            availablePopulateUsecase.execute({ companyId }),
                            dashboardAvailable.populate({
                                companyId
                            })
                        ]);
                    }
                ]
            }
        })
        .state("nucont.reports.company.visualization", {
            url: "/dashboard/:reportId?contactId",
            params: {
                contactId: null,
                reportId: null,
                generate: false,
                lastState: null,
                arrowRule: null,
                fromEmail: null
            },
            views: {
                "empty@nucont.reports.company": {
                    component: "reportsVisualizationComponent",
                    bindings: { companyData: "CompanyData" }
                }
            },
            resolve: {
                checkLogin: [
                    "$stateParams",
                    "$state",
                    "user",
                    async ($stateParams, $state, user) => {
                        if (!user) {
                            console.log("REPORT NO USER", $stateParams);
                            $state.go("nucont.authentication", {
                                redirectToStateName:
                                    "nucont.reports.company.visualization",
                                redirectToStateParams: $stateParams
                            });
                            return false;
                        } else {
                            return true;
                        }
                    }
                ]
            },
            bodyClass: "report-visualization-module"
        })
        .state("nucont.reports.company.rules", {
            url: "/regras/:reportId?contactId&isGoals",
            params: {
                contactId: null,
                reportId: null,
                generate: false,
                lastState: null,
                arrowRule: null,
                isGoals: null
            },
            views: {
                "empty@nucont.reports.company": {
                    component: "reportRulesComponent",
                    bindings: { companyData: "CompanyData" }
                }
            },
            data: {
                layoutConfig: {
                    model: "LayoutConfigModel6"
                }
            },
            resolve: {
                checkLogin: [
                    "$stateParams",
                    "$state",
                    "user",
                    async ($stateParams, $state, user) => {
                        if (!user) {
                            console.log("REPORT NO USER", $stateParams);
                            $state.go("nucont.authentication", {
                                redirectToStateName:
                                    "nucont.reports.company.rules",
                                redirectToStateParams: $stateParams
                            });
                            return false;
                        } else {
                            return true;
                        }
                    }
                ]
            },
            bodyClass: "report-visualization-module"
        })
        .state("nucont.reports.company.dre", {
            url: "/dre/:reportId?contactId",
            params: {
                contactId: null,
                reportId: null,
                generate: false,
                lastState: null,
                arrowRule: null
            },
            views: {
                "empty@nucont.reports.company": {
                    component: "reportsDreComponent",
                    bindings: { companyData: "CompanyData" }
                }
            },
            data: {
                layoutConfig: {
                    model: "LayoutConfigModel6"
                }
            },
            resolve: {
                checkLogin: [
                    "$stateParams",
                    "$state",
                    "user",
                    async ($stateParams, $state, user) => {
                        if (!user) {
                            console.log("REPORT NO USER", $stateParams);
                            $state.go("nucont.authentication", {
                                redirectToStateName:
                                    "nucont.reports.company.dre",
                                redirectToStateParams: $stateParams
                            });
                            return false;
                        } else {
                            return true;
                        }
                    }
                ]
            },
            bodyClass: "report-visualization-module"
        })
        .state("nucont.reports.company.dre.comparation", {
            url: "/comparacao",
            views: {
                "empty@nucont.reports.company": {
                    component: "reportsDreComparationComponent",
                    bindings: { companyData: "CompanyData" }
                }
            },
            data: {
                layoutConfig: {
                    model: "LayoutConfigModel6"
                }
            },
            resolve: {
                checkLogin: [
                    "$stateParams",
                    "$state",
                    "user",
                    async ($stateParams, $state, user) => {
                        if (!user) {
                            console.log("REPORT NO USER", $stateParams);
                            $state.go("nucont.authentication", {
                                redirectToStateName:
                                    "nucont.reports.company.dre.comparation",
                                redirectToStateParams: $stateParams
                            });
                            return false;
                        } else {
                            return true;
                        }
                    }
                ]
            },
            bodyClass: "report-visualization-module"
        })
        .state("nucont.reports.company.balance", {
            url: "/balanco/:reportId?contactId",
            params: {
                contactId: null,
                reportId: null,
                generate: false,
                lastState: null,
                arrowRule: null
            },
            views: {
                "empty@nucont.reports.company": {
                    component: "reportBalanceComponent",
                    bindings: { companyData: "CompanyData" }
                }
            },
            data: {
                layoutConfig: {
                    model: "LayoutConfigModel6"
                }
            },
            resolve: {
                checkLogin: [
                    "$stateParams",
                    "$state",
                    "user",
                    async ($stateParams, $state, user) => {
                        if (!user) {
                            console.log("REPORT NO USER", $stateParams);
                            $state.go("nucont.authentication", {
                                redirectToStateName:
                                    "nucont.reports.company.balance",
                                redirectToStateParams: $stateParams
                            });
                            return false;
                        } else {
                            return true;
                        }
                    }
                ]
            },
            bodyClass: "report-visualization-module"
        })
        .state("nucont.reports.company.balance.comparation", {
            url: "/comparacao",
            views: {
                "empty@nucont.reports.company": {
                    component: "reportBalanceComparationComponent",
                    bindings: { companyData: "CompanyData" }
                }
            },
            data: {
                layoutConfig: {
                    model: "LayoutConfigModel6"
                }
            },
            resolve: {
                checkLogin: [
                    "$stateParams",
                    "$state",
                    "user",
                    async ($stateParams, $state, user) => {
                        if (!user) {
                            console.log("REPORT NO USER", $stateParams);
                            $state.go("nucont.authentication", {
                                redirectToStateName:
                                    "nucont.reports.company.balance.comparation",
                                redirectToStateParams: $stateParams
                            });
                            return false;
                        } else {
                            return true;
                        }
                    }
                ]
            },
            bodyClass: "report-visualization-module"
        })
        .state("nucont.reports.company.projection", {
            url: "/projecao/:reportId?contactId",
            params: {
                contactId: null,
                reportId: null,
                generate: false,
                lastState: null,
                arrowRule: null,
                fromEmail: null
            },
            views: {
                "empty@nucont.reports.company": {
                    component: "reportsProjectionComponent",
                    bindings: { companyData: "CompanyData" }
                }
            },
            data: {
                layoutConfig: {
                    model: "LayoutConfigModel6"
                }
            },
            resolve: {
                checkLogin: [
                    "$stateParams",
                    "$state",
                    "user",
                    async ($stateParams, $state, user) => {
                        if (!user) {
                            console.log("REPORT NO USER", $stateParams);
                            $state.go("nucont.authentication", {
                                redirectToStateName:
                                    "nucont.reports.company.projection",
                                redirectToStateParams: $stateParams
                            });
                            return false;
                        } else {
                            return true;
                        }
                    }
                ]
            },
            bodyClass: "report-visualization-module"
        })
        .state("nucont.reports.company.budget", {
            url: "/orcamento/:reportId?contactId",
            params: {
                contactId: null,
                reportId: null,
                generate: false,
                lastState: null,
                arrowRule: null,
                fromEmail: null
            },
            views: {
                "empty@nucont.reports.company": {
                    component: "reportsBudgetComponent",
                    bindings: { companyData: "CompanyData" }
                }
            },
            data: {
                layoutConfig: {
                    model: "LayoutConfigModel6"
                }
            },
            resolve: {
                checkLogin: [
                    "$stateParams",
                    "$state",
                    "user",
                    async ($stateParams, $state, user) => {
                        if (!user) {
                            console.log("REPORT NO USER", $stateParams);
                            $state.go("nucont.authentication", {
                                redirectToStateName:
                                    "nucont.reports.company.budget",
                                redirectToStateParams: $stateParams
                            });
                            return false;
                        } else {
                            return true;
                        }
                    }
                ]
            },
            bodyClass: "report-visualization-module"
        });
}
